import { Component, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { FinancialInstitutionLender, RequestMethod } from '@models/lender';
import { Select } from '@ngxs/store';
import { ClipboardService } from '@services/clipboard/clipboard.service';
import { DefaultEmailSubjectSelectors } from '@state/global/default-email';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-payout-message',
	templateUrl: './payout-message.component.html',
	standalone: false,
})
export class PayoutMessageComponent {
	constructor(private clipboard: ClipboardService) {}

	@Select(DefaultEmailSubjectSelectors.defaultEmailSubject)
	public emailSubject$: Observable<string>;

	@Input() set institution(_finInst: FinancialInstitutionLender) {
		this.resetInitialDataState();

		const requestMethod = _finInst?.discharge?.requestMethod;
		switch (requestMethod) {
			case RequestMethod.LLC:
				this.message = 'Payout statement must be requested via LLC.';
				this.label = 'Launch LLC';
				this.link = 'https://payout.firstcdn.com/Profile/Login.aspx';
				break;
			case RequestMethod.LENDER_CENTER:
				this.message = 'Payout statement must be requested via Lender Centre.';
				this.label = 'Launch Lender Centre';
				this.link = 'https://unity.doprocess.com/login/home';
				break;
			case RequestMethod.EMAIL:
				this.message = 'Payout statement must be requested via email.';
				this.label = 'Email';
				this.email = _finInst?.discharge?.email || _finInst?.email;
				break;
			case RequestMethod.FAX:
				this.message = 'Payout statement must be requested via fax.';
				this.label = 'Fax';
				this.fax = _finInst?.discharge.fax || _finInst?.fax;
				break;
			default:
				if (this.branchId === 'HPtJMx4') {
					this.message =
						'First National payout requests must be obtained through LLC.';
					this.label = 'Go to LLC';
					this.link = 'https://payout.firstcdn.com/Profile/Login.aspx';
				}
		}
		this.showMessage = !!this.message;
	}

	@Input() branchId = '';
	public ICON = ICON;

	public message = '';
	public label = '';
	public link = '';
	public email = '';
	public fax = '';

	public showMessage = false;

	resetInitialDataState() {
		this.message = '';
		this.label = '';
		this.link = '';
		this.email = '';
		this.fax = '';

		this.showMessage = false;
	}

	copyToClipboard(text: string) {
		this.clipboard.copyText(text, true);
	}

	openExternalLink() {
		window.open(this.link, '_blank');
	}
}
